/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { useRef, useState, forwardRef } from 'react';
import play from '../../../assets/player_overlay.png' 
import Aside from '../Aside/Aside';
import './S2txtStream.scss'
import ReactPlayer from 'react-player'
import Marquee from "react-fast-marquee";
import screenfull from 'screenfull'
import { useEffect } from 'react';
import { Slider, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import firebase from '../../../utils/firebase'
import { useDispatch, useSelector } from 'react-redux';
import { setEventId, setLoadFailed, setLoadSuccess } from '../../../redux/actions/s2txtActions';
import VideoStream from './VideoStream';


const gghh = [
    {
        color: '#2BE90C',
        text: 'You must be blind',
        status: 'Showing'
    },

    {
        color: '#F2E601',
        text: 'You must be blind',
        status: 'Showing'
    },
    {
        color: '#FFBF00',
        text: 'You must be blind',
        status: 'Showing'
    },
    {
        color: '#019AF2',
        text: 'You must be blind',
        status: 'hidden'
    },
    {
        color: '#F201DF',
        text: 'You must be blind',
        status: 'Showing'
    },
    {
        color: '#F20101',
        text: 'You must be blind',
        status: 'Showing'
    },

]


const VolumeSlider = withStyles({
    root: {
      color: 'rgb(230, 230, 230)',
      height: 0,
      padding: 0,
      paddingTop: 2,
      margin: '0.1rem 0 0 0',
     
      width: 100,
     
     
    },
    thumb: {
      height: 10,
      width: 10,
      backgroundColor: 'rgb(230, 230, 230)',
      border: '1px solid rgb(230, 230, 230)',
      marginTop: -4,
      marginLeft: -0,
      '&:focus, &:hover, &$active': {
        boxShadow: 'inherit',
      },
    },
    active: {},
    valueLabel: {
      left: 'calc(-50% + 4px)',
    },
    track: {
      height: 3,
      borderRadius: 4,
    },
    rail: {

      height: 3,
      borderRadius: 4,
      backgroundColor: '#525252',
      opacity: 1
    },
  })(Slider);


function ValueLabelComponent(props) {
    const { children, open, value } = props;
  
    return (
      <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
        {children}
      </Tooltip>
    );
  }

  const PrettoSlider = withStyles({
    root: {
      color: '#da3849',
      height: 0,
      padding: 0,
      paddingTop: 3,
      position: 'absolute',
      top: -6,
      width: '98.8%'
     
    },
    thumb: {
      height: 10,
      width: 10,
      backgroundColor: '#da3849',
      border: '2px solid currentColor',
      marginTop: -4,
      marginLeft: -0,
      '&:focus, &:hover, &$active': {
        boxShadow: 'inherit',
      },
    },
    active: {},
    valueLabel: {
      left: 'calc(-50% + 4px)',
    },
    track: {
      height: 3,
      borderRadius: 4,
    },
    rail: {

      height: 3,
      borderRadius: 4,
      backgroundColor: '#909090',
      opacity: 1
    },
  })(Slider);

  const getDate = () => {
    const months = {
    0: 'Jan',
    1: 'Feb',
    2: 'Mar',
    3: 'Apr',
    4: 'May',
    5: 'Jun',
    6: 'Jul',
    7: 'Aug',
    8: 'Sept',
    9: 'Oct',
    10: 'Nov',
    11: 'Dec'
    }
    let date = ('00' + new Date(Date.now()).getDate()).slice(-2)
    let month = months[new Date(Date.now()).getMonth()]
    
  
    return [date, month]
  }


  

const TransStream = ({username, setSuccess}) => {
    
    const langTxtDetails = useSelector(state => state.langTxtDetails)
    const loadingStatus = useSelector(state => state.loadingStatus)
    const { status } = loadingStatus
    const { language } = langTxtDetails
    const dispatch = useDispatch()
    const [eventsData, setEventsData] = useState([]);
    const [eventTitle, setEventTitle] = useState('');
    const [eventStatus, setEventStatus] = useState('');
    const [eventDate, setEventDate] = useState('');
    const [eventTime, setEventTime] = useState('');
    const [eventID, setEventID] = useState('')
    const [noticeData, setNoticeData] = useState([])
    const [videoSrc, setVideoSrc] = useState('');
    const [audioSrc, setAudioSrc] = useState('')
    const [eventImage, setEventImage] = useState('');
    const [eventDescription, setEventDescription] = useState('');
    const [day, setDay] = useState('');
    const [month, setMonth] = useState('');
    const [playing, setPlaying] = useState(false)
    const [languagesData, setLanguagesData] = useState([]);
    const [loadVideo, setLoadVideo] = useState(false);
    const playerContainerRef = useRef(null)
    const [error, setError] = useState(!status);
    const [viewState, setViewState] = useState('video')
    const [loadAudio, setLoadAudio] = useState(false)
    const [audioPlaying, setAudioPlaying] = useState(false)
    const [desState, setDesState] = useState(true)

    useEffect(() => {
        let main = document.querySelector('.s2txtMain')
        if(main.clientWidth < 800) {
            if (eventDescription) {
                let text = document.querySelector('.describe')
                if (document.getElementsByClassName('bot-mob hide')[0] && desState) {
                    let bb = document.getElementsByClassName('bot-mob hide')[0] 
                    // let btn = document.querySelector('.attend-btn')
                    bb.querySelector('.describe').style.transform = `translateY(-${text.clientHeight + 10}px)`
                    // btn.style.transform = `translateY(-${text.clientHeight + 10}px)`
                }
    
                if (document.getElementsByClassName('bot-mob')[0] && !desState) {
                    let bb = document.getElementsByClassName('bot-mob')[0]
                    // let btn = document.querySelector('.attend-btn')
                    // btn.style.transform = 'translateY(0rem)'
                    bb.querySelector('.describe').style.transform = 'translateY(0rem)'
                }
                
                
            }
        } else {
            let bb = document.getElementsByClassName('bot-mob')[0]
            let btn = document.querySelector('.attend-btn')
            btn.style.transform = 'translateY(0rem)'
            bb.querySelector('.describe').style.transform = 'translateY(0rem)'
        }
        
    }, [desState, eventDescription])

    
    useEffect(() => {
        if (eventID) {
            const noticeRef = firebase.database().ref('Events').child(eventID).child('Notice')
            noticeRef.on('value', (el) => {
                let eData = []
                for (let id in el.val()) {
                    eData.push({id, ...el.val()[id]})
                }
                setNoticeData(eData)
            })
        }
        
    }, [eventID])


    useEffect(() => {
        const eventRef = firebase.database().ref('Events')

        eventRef.on('value', (el) => {
            let eData = []
            for (let id in el.val()) {
                eData.push({id, ...el.val()[id]})
            }

            if (eData.length !== eventsData.length) {
                setEventsData(eData)
            } else {
                for (let i = 0; eData.length < i; i++) {
                
                    if (eData[i] !== eventsData[i]) {
                        
                    };
                }
            }

            

            
        })

        const check = eventsData.some(el => {
            return el.eventStatus === 'Live'
        })

        if(check) {
            eventsData.forEach(el => {
                if (el.eventStatus === 'Live') {
                    setEventTitle(el.eventName)
                    setEventDate(el.eventDate)
                    setEventTime(el.eventTime)
                    setEventStatus(el.eventStatus)
                    setEventDescription(el.description)
                    setEventImage(el.eventImageUrl)
                    setEventID(el.id)
                    dispatch(setEventId(el.id))
                    return
                }
            })
        }
        if (!check) {
            eventsData.forEach(el => {
                if (el.eventStatus === 'Default') {
                    setEventTitle(el.eventName)
                    setEventDate(el.eventDate)
                    setEventTime(el.eventTime)
                    setEventStatus(el.eventStatus)
                    setEventDescription(el.description)
                    setEventImage(el.eventImageUrl)
                    setEventID(el.id)
                    dispatch(setEventId(el.id))
                    return
                }
            })  
                
            }
        // console.log(typeof eventData[1].eventStatus)
    }, [eventsData])
    
    useEffect(() => {
        if(loadAudio) {
            var elem = document.querySelector("video");
            elem.remove();
        }
        
    }, [loadAudio])

    useEffect(() => {
        let ff = getDate()
        setDay(ff[0])
        setMonth(ff[1])
    }, [])

    useEffect(() => {
        setError(!status)
        setPlaying(false)
    }, [status])

    
    useEffect(() => {
        const langRef = firebase.database().ref('Languages')

        langRef.on('value', (el) => {
            let eData = []
            for (let id in el.val()) {
                eData.push({id, ...el.val()[id]})
            }
            setLanguagesData(eData)
           
        })
    }, [])

    useEffect(() => {
        languagesData.forEach(el => {
            if(el.language === language) {
                setVideoSrc(el.streamUrl)
                setAudioSrc(el.audioUrl)
            }
        })
    }, [language, languagesData])


    const handleVideoStart = () => {
        setPlaying(true)
        setLoadVideo(true)
    }

    


    const handleMouseOver = () => {
        // if (document.querySelector('.video-controls')) {
        //     document.querySelector('.controls').classList.remove('remove')
        // }
 
    }

    

    
    


    return (
        

        <section className='txt-stream marg'>
            

            <div className="stream">
                <div className="top">
                    <div className="t-left">
                        <p>{day}</p>
                        <p>{month}</p>
                    </div>

                    <div className='t-right'>
                        <i>Now showing</i>
                        <h2>{eventTitle}</h2>
                    </div>
                </div>

                <div className="middle">
                    {viewState === 'video' && !loadVideo?
                        <div ref={playerContainerRef} className="video ">
                            <img src={eventImage} alt="cover" />
                            <img src={play} alt="play button" onClick={handleVideoStart}/>
                        </div>
                    : viewState === 'video' && loadVideo?
                        <div ref={playerContainerRef} className="video" onMouseUp={handleMouseOver} onMouseDown={handleMouseOver}>
                            <VideoStream setLoadAudio={setLoadAudio} setAudioPlaying={setAudioPlaying} setLoadVideo={setLoadVideo} setViewState={setViewState} viewState={viewState}
                            videoSrc={videoSrc} playerContainerRef={playerContainerRef} setError={setError} playing={playing} setPlaying={setPlaying}/>
                            
                        </div>
                    : viewState === 'video' && error? <div className="error-container">
                        
                        <p>Your Either Having Network Issues Or {language} Stream Isn't Live Yet</p>
                    </div>
                    : viewState === 'audio' && !loadAudio?
                    <div className="video audio">
                        <img src={eventImage} alt="cover" />
                        <VideoStream setLoadAudio={setLoadAudio} setAudioPlaying={setAudioPlaying} setLoadVideo={setLoadVideo} setViewState={setViewState} viewState={viewState}
                        videoSrc={audioSrc} playerContainerRef={playerContainerRef} setError={setError} playing={audioPlaying} setPlaying={setAudioPlaying} audio/>
                       
                         </div>
                    : ''
                    }    
                </div>

                <div className='bottom bot-mob hide'>
                    {noticeData.filter(el => el.status === 'Showing').length > 0? 
                        <marquee width="60%" direction="left" height="100px">
                            <p>{noticeData.filter(el => el.status === 'Showing').map((el, i) => {
                                return (
                                    <span style={{color: `${el.color}`}}>
                                        #{i+ 1} {el.text}
                                    </span>
                                )
                            })}</p>
                                
                        </marquee>

                        : <div className="notice-board" >
                             <p>Notice Board</p>
                          </div>
                    }                   
                    <p className='describe' >
                        {eventDescription}
                    </p>

                    
                </div>             
            </div>

            <Aside username={username} setDesState={setDesState}/>
            
        </section>
    )
}

export default TransStream